<template>
  <footer class="footer">
    <ul class="footer_menu pl-0">
      <li class="arrow"><router-link :to="{ name: 'PageFixed', params: { code: 'how_to_use' } }" class="footer_link--text">ご利用方法</router-link></li>
      <li class="arrow"><router-link :to="{ name: 'PageFixed', params: { code: 'about_points' } }" class="footer_link--text">ポイントについて</router-link></li>
      <li v-if="user.user != null" class="arrow"><router-link :to="{ name: 'PageFixed', params: { code: 'contact_us' } }" class="footer_link--text">お問い合わせ</router-link></li>
      <li v-else class="arrow"><a :href="`mailto:${settingData.inquiry_mail}?subject=お問い合わせ`" class="footer_link--text">お問い合わせ</a></li>
      <li class="arrow"><router-link :to="{ name: 'PageFixed', params: { code: 'faq' } }" class="footer_link--text">よくある質問</router-link></li>
      <li class="arrow"><router-link :to="{ name: 'PageFixed', params: { code: 'terms_of_service' } }" class="footer_link--text">利用規約</router-link></li>
      <li class="arrow"><router-link :to="{ name: 'PageFixed', params: { code: 'company_profile' } }" class="footer_link--text">会社概要</router-link></li>
      <li class="arrow"><router-link :to="{ name: 'PageFixed', params: { code: 'specified_commercial_transactions' } }" class="footer_link--text">特定商取引法に基づく表記</router-link></li>
      <li class="arrow"><router-link :to="{ name: 'PageFixed', params: { code: 'privacy_policy' } }" class="footer_link--text">プライバシーポリシー</router-link></li>
      <li class="arrow"><router-link :to="{ name: 'PageFixed', params: { code: 'withdrawal' } }" class="footer_link--text">退会</router-link></li>
    </ul>
    <nav class="footer_nav text_center">
      <ul v-if="user.user != null" class="pl-0">
        <li><router-link to="/" class="footer_link--text">ホーム</router-link></li>
        <li><router-link :to="{ name: 'MailList' }" class="footer_link--text">鑑定結果</router-link></li>
        <li><router-link :to="{ name: 'PointPurchase' }" class="footer_link--text">PT購入</router-link></li>
        <li><router-link :to="{ name: 'PageFixed', params: { code: 'contact_us' } }" class="footer_link--text">お問い合わせ</router-link></li>
      </ul>
      <ul v-else class="pl-0">
        <li><router-link to="/" class="footer_link--text">ホーム</router-link></li>
        <li class="footer_link--text">鑑定結果</li>
        <li class="footer_link--text">PT購入</li>
        <li><a :href="`mailto:${settingData.inquiry_mail}?subject=お問い合わせ`" class="footer_link--text">お問い合わせ</a></li>
      </ul>
    </nav>
    <div class="copyright text_center">&copy;&nbsp;{{ info.title }}</div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      user: this.$store.getters.loginUser || null,
      info: this.$store.getters.siteInfo || null,
      settingData: []
    }
  },
  computed: {
    loginUser () {
      return this.$store.getters.loginUser
    },
    siteInfo () {
      return this.$store.getters.siteInfo
    }
  },
  watch: {
    loginUser (val, old) {
      this.user = val
    },
    siteInfo (val, old) {
      this.info = val
    }
  },
  methods: {
    getDefaultSetting () {
      this.$store.dispatch('getDefaultSetting')
        .then((data) => {
          this.settingData = data
        })
    }
  },
  created () {
    this.getDefaultSetting()
  }
}
</script>
